<template>
  <div>
    <button @click="toggleForm">{{ isFormVisible ? 'Hide' : 'Show' }} SEO Options</button>

    <div v-if="isFormVisible">
      <el-form :model="form" ref="seoForm" label-width="120px" :rules="rules">
        <el-form-item label="H1" prop="title">
          <el-input v-model="form.title" placeholder="Enter title"></el-input>
        </el-form-item>

        <el-form-item label="SEO Title" prop="seo_title">
          <el-input
              v-model="form.seo_title"
              placeholder="Enter title for SEO"
          ></el-input>
        </el-form-item>

        <el-form-item label="SEO Description" prop="seo_description">
          <el-input
              type="textarea"
              v-model="form.seo_description"
              placeholder="Enter description for SEO"
          ></el-input>
        </el-form-item>

        <el-form-item label="Preview description" prop="excerpt">
          <el-input
              type="textarea"
              v-model="form.excerpt"
              placeholder="Enter preview description"
          ></el-input>
        </el-form-item>

        <el-form-item label="Slug" prop="slug">
            <el-input
                type="textarea"
                v-model="form.slug"
            ></el-input>
          <button @click="redirectToLink" style="cursor: pointer;">GO TO PAGE</button>
        </el-form-item>

        <el-form-item label="Date" prop="date">
          <el-date-picker
              v-model="form.date"
              placeholder="Select date"
              type="date"
              format="MM-dd-yyyy"
              value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="Authors" prop="author_id">
          <el-select
              v-model="form.author.id"
              placeholder="Select author"
          >
            <el-option
                v-for="author in authors"
                :key="author.id"
                :label="author.name"
                :value="author.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Categories" prop="categories">
          <el-select
              v-model="form.categories"
              multiple
              placeholder="Select categories"
          >
            <el-option
                v-for="category in categoriesList"
                :key="category.id"
                :label="category.name"
                :value="category.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Tags" prop="tags">
          <el-select
              v-model="form.tags"
              multiple
              placeholder="Select tags"
          >
            <el-option
                v-for="tag in tags"
                :key="tag.id"
                :label="tag.name"
                :value="tag.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Status" prop="status">
          <el-select v-model="form.status" placeholder="Select status">
            <el-option label="Draft" value="draft"></el-option>
            <el-option label="Published" value="publish"></el-option>
          </el-select>
        </el-form-item>

<!--        <el-form-item label="Seo image" prop="seo_image">-->
<!--          <div class="upload-image">-->
<!--            <img v-if="form.seo_image" :src="form.seo_image.url" class="preview-image" />-->
<!--            <i class="el-icon-upload"></i>-->
<!--            <input-->
<!--                @change="seoImgReader"-->
<!--                type="file"-->
<!--                accept="image/jpeg,image/png"-->
<!--                class="input-file"-->
<!--                title="drop image here">-->
<!--          </div>-->
<!--        </el-form-item>-->

        <el-form-item label="Blog list image" prop="image">
          <div class="upload-image">
            <img v-if="form.image" :src="form.image.url" class="preview-image" />
            <i class="el-icon-upload"></i>
            <input
                @change="imgReader"
                type="file"
                accept="image/jpeg,image/png"
                class="input-file"
                title="drop image here">
          </div>
        </el-form-item>
      </el-form>
  </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  props: {
    formData: {}
  },
  data() {
    return {
      isFormVisible: true,
      form: {
        title: '',
        seo_title: '',
        excerpt: '',
        date: null,
        categories: [],
        tags: [],
        status: '',
        // seo_image: null,
        image: null,
        author: {}
      },
      rules: {
        title: [
            {required: true, message: 'Please, input title!'},
        ],
        seo_title: [
            {required: true, message: 'Please, input seo title!'},
        ],
        seo_description: [
            {required: true, message: 'Please, input seo description!'},
        ],
        slug: [
          {
            validator: this.validateSlug,
            trigger: 'blur'
          }
        ],
        excerpt: [{required: true, message: 'Please, input excerpt!'}],
        date: [{required: true, message: 'Please, input date!'}],
        author: [{required: true, message: 'Please, input author!'}],
        categories: [
          { required: true, message: 'Please select at least one category', trigger: 'change' },
        ],
        tags: [
          { required: true, message: 'Please select at least one tag', trigger: 'change' },
        ],
        // seo_image: [
        //   {
        //     validator: this.validateSeoImage,
        //     message: "SEO image is required",
        //     trigger: "change",
        //   },
        // ],
        image: [
          {
            validator: this.validateImage,
            message: "Image is required",
            trigger: "change",
          },
        ],
      }
    };
  },
  computed: {
    ...mapGetters({
      categoriesList: 'posts/getCategories',
      tags: 'posts/getTags',
      authors: 'posts/getAuthors'
    }),
  },
  created() {
    this.$store.dispatch('posts/getAuthors');
    this.$store.dispatch('posts/getCategories');
    this.$store.dispatch('posts/getTags',{
      sort_column: 'name',
      sort_direction: 'ASC'
    });
    this.$emit('form-updated', {...this.form});
    if(this.$route.params.id) {
      this.form = this.formData;
      this.form.categories = this.form.categories.map((category) => category.id)
      this.form.tags = this.form.tags.map((tag) => tag.id)
    }
  },
  watch: {
    form: {
      deep: true,
      handler(newForm) {
        this.$refs.seoForm.validate((valid) => {
          if(valid) {
            this.$emit('form-updated', {...newForm});
          } else {
            this.$emit('form-updated', 'form not validated');
          }
        })
      }
    }
  },
  methods: {
    toggleForm() {
      this.isFormVisible = !this.isFormVisible;
    },
    // seoImgReader(e) {
    //   this.form.seo_image = e.target.files[0];
    // },
    imgReader(e) {
      this.form.image = e.target.files[0];
    },
    redirectToLink() {
      window.open(`${process.env.VUE_APP_MAIN_SITE}/blog/${this.formData.slug}`);
    },
    validateSlug(rule, value, callback) {
      if(value === '') {
        callback();
      }
      const slugPattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
      if (!slugPattern.test(value)) {
        callback(new Error('Slug must be in a valid link format (lowercase, hyphens allowed)'));
      } else {
        callback();
      }
    },
    // validateSeoImage(rule, value, callback) {
    //   if (!this.form.seo_image) {
    //     callback(new Error("SEO image is required"));
    //   } else {
    //     callback();
    //   }
    // },
    validateImage(rule, value, callback) {
      if (!this.form.image) {
        callback(new Error("SEO image is required"));
      } else {
        callback();
      }
    },
  }
};
</script>

<style scoped>
label {
  display: block;
  margin-bottom: 5px;
}

input,
textarea,
select {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

button {
  padding: 10px 15px;
  background-color: #3490dc;
  color: white;
  border: none;
  cursor: pointer;
  margin-bottom: 10px;
}

button:hover {
  background-color: #2779bd;
}

.upload-image {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-image {
  max-width: 140px;
  max-height: 110px;
  object-fit: contain;
  border-radius: 4px;
}
</style>
